import { useEffect, useMemo } from 'react';
import type { ReactNode } from 'react';
import { ConfigProvider } from 'antd';
import { kebabCase } from 'lodash';
import { useAppSelector } from 'app/hooks';
import { selectBrandCode } from 'services/brand/brandSelectors';
import BRAND_THEME_CONFIG from './config';

type Props = { children: ReactNode };

function ConfigTheme({ children }: Props) {
  const brandCode = useAppSelector(selectBrandCode);

  useEffect(() => {
    const root = document.documentElement;
    const variables =
      BRAND_THEME_CONFIG[brandCode]?.variables ??
      BRAND_THEME_CONFIG.default.variables;

    if (variables) {
      Object.keys(variables).forEach((key) => {
        root.style.setProperty(`--${kebabCase(key)}`, variables[key]);
      });
    }
  }, [brandCode]);

  const themeConfig = useMemo(() => {
    return (
      BRAND_THEME_CONFIG[brandCode]?.config ?? BRAND_THEME_CONFIG.default.config
    );
  }, [brandCode]);

  return <ConfigProvider theme={themeConfig}>{children}</ConfigProvider>;
}

export default ConfigTheme;
